import { productsAPI } from "services/productsService";
import { ICartItem } from "store/types/cartTypes";
import { handleOnProductChange } from "./socketHandlers";
import { store } from "store/Store";
import { isKit } from "./itemTypeHelpers";

export interface IValidProductResponse {
  product: {
    id: string;
    variants: string[];
  };
}

export interface IValidProductGroupResponse {
  productGroup: {
    productGroupId: string;
    productGroup: any | null; // null means no longer available
  };
}

export interface IGetValidVariantsResponse {
  products: IValidProductResponse[];
  productGroups: IValidProductGroupResponse[];
}

export const validateLocalCartOnStartup = async (): Promise<ICartItem[]> => {
  const localCart: ICartItem[] = JSON.parse(
    localStorage.getItem("cart") || "[]"
  );
  if (!localCart.length) return [];

  const productIds = Array.from(
    new Set(
      localCart
        .filter((item) => !isKit(item))
        .map((item) => item.productId)
    )
  );

  const productGroupIds = Array.from(
    new Set(
      localCart
        .filter((item) => isKit(item))
        .map((item) => item.productId)
    )
  );

  try {
    const response: IGetValidVariantsResponse =
      await productsAPI.getValidVariants({ productIds, productGroupIds });

    const { products, productGroups } = response;

    // Convert to a singular array for socket handler compatibility
    const flattenedResponse = [
      ...products,
      ...productGroups.map(pg => ({
        product: {
          id: pg.productGroup.productGroupId,
          variants: pg.productGroup.productGroup ? [] : ["__UNAVAILABLE__"] // Marker for removal if null
        }
      }))
    ];

    handleOnProductChange(store.dispatch, store.getState, flattenedResponse as any);

    const validCartItems = localCart.filter((item) => {
      if (isKit(item)) {
        const pg = productGroups.find(
          (p) => p.productGroup.productGroupId === item.productId
        );
        // Kit is valid ONLY if productGroup entry exists AND the nested productGroup is not null
        return pg && pg.productGroup.productGroup !== null;
      }

      const product = products.find(
        (p) => p.product.id === item.productId
      );
      return product && product.product.variants.includes(item.variantId);
    });

    return validCartItems;
  } catch (err) {
    console.error("Error validating local cart:", err);
    return localCart;
  }
};
